import React, { useState } from "react";
import styles from "./ReverseCAGRCalculator.module.css";

const ReverseCAGRCalculator = () => {
  const [startValue, setStartValue] = useState("");
  const [cagr, setCagr] = useState("");
  const [years, setYears] = useState("");
  const [finalValue, setFinalValue] = useState(null);
  const [growthData, setGrowthData] = useState([]);
  const [error, setError] = useState("");

  const formatIndianNumber = (num) => {
    return Number(num).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const calculateReverseCAGR = () => {
    setError("");
    setFinalValue(null);
    setGrowthData([]);

    if (!startValue || !cagr || !years) {
      setError("Please fill in all the fields.");
      return;
    }

    if (startValue <= 0 || cagr < 0 || years <= 0) {
      setError("Please enter valid positive values.");
      return;
    }

    try {
      const rate = cagr / 100;
      const finalVal = startValue * Math.pow(1 + rate, years);
      setFinalValue(finalVal);

      const yearlyGrowth = [];
      for (let i = 0; i <= years; i++) {
        const value = startValue * Math.pow(1 + rate, i);
        yearlyGrowth.push({ year: i, value });
      }
      setGrowthData(yearlyGrowth);
    } catch (err) {
      setError("An error occurred during calculation.");
    }
  };

  return (
    <div className={styles.container}>

      <div className={styles.card}>
      
        <h1 className={styles.title}>Reverse CAGR Calculator</h1>

        <div className={styles.inputGroup}>

          <div>
            <label>Start Value</label>
            <input
              type="number"
              value={startValue}
              onChange={(e) => setStartValue(e.target.value)}
              placeholder="e.g. 12000"
            />
          </div>
          
          <div>
            <label>CAGR (%)</label>
            <input
              type="number"
              value={cagr}
              onChange={(e) => setCagr(e.target.value)}
              placeholder="e.g. 3.74"
            />
          </div>
        
          <div>
            <label>Number of Years</label>
            <input
              type="number"
              value={years}
              onChange={(e) => setYears(e.target.value)}
              placeholder="e.g. 20"
            />
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <button type="submit" onClick={calculateReverseCAGR}>Calculate</button>
        </div>

        {error && <p className={styles.error}>{error}</p>}
      
        {finalValue !== null && (
          <>
            <h3 className={styles.result}>
              Final Value: <span> {formatIndianNumber(finalValue)}</span>
            </h3>

            <div className={styles.growthContainer}>
              <div className={`${styles.growthRow} ${styles.headerRow}`}>
                <div className={styles.yearCol}>Year</div>
                <div className={styles.valueCol}>Value</div>
              </div>

              <div className={styles.growthDataContainer} >
                {growthData.map((item) => (
                  <div key={item.year} className={styles.growthRow}>
                    <div className={styles.yearCol}>{item.year}</div>
                    <div className={styles.valueCol}>
                      {formatIndianNumber(item.value)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

      </div>

    </div>
  );
};

export default ReverseCAGRCalculator;
